export default __webpack_public_path__ + "static/media/adidas.acfd0647.svg";